<template>
    <div class="row">
        <!-- main title -->
        <div class="col-12">
            <div class="main__title">
                <h2>گروه سنی</h2>
            </div>
        </div>
        <!-- end main title -->

        <!-- form -->
        <div class="col-12">
            <div class="form">
                <div class="row">


                    <div class="col-8 col-md-8 ">
                        <div class="row">
                            <div class="col-12">
                                <div class="form__group">
                                    <input v-model="name" type="text" class="form__input" placeholder="نام ">
                                </div>
                            </div>


                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form__group">
                            <label class="form-control">توضیحات</label>
                            <textarea v-model="bio" type="text" class="form__input" ></textarea>
                        </div>
                    </div>

                    <div class="col-4 col-md-4 ">
                                <div class="form__group">
                                    <ImageSelector label="تصویر"
                                                   v-model:previewImage="file_preview"
                                                   @imagefile="(n) => file = n"
                                                   />

                                </div>
                    </div>
  <div class="col-4 col-md-4 ">

                    </div>


                    <div class="col-12">
                        <div class="row">

                            <div class="col-12">
                                <button type="button" class="form__btn" @click="insert_data">{{status_form ==0 ?
                                    'افزودن' : 'ویرایش'}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12">

            <div class="row">
                <!-- main title -->
                <!-- end main title -->

                <!-- users -->
                <div class="col-12">
                    <Datatable
                            :items="items"
                            :fields="fields"
                            style="overflow: auto"
                            :items-per-page="20"
                            hover
                            title="لیست رده های سنی"
                            height="300px"
                            border
                            striped
                            sorter
                            column-filter
                            pagination
                    >
                        <template #row="{item,index}">
                            <td>
                                <div class="main__table-text">{{index+1}}</div>
                            </td>
                        </template>
                        <template #image="{item}">
                            <td>
                                <div class="main__table-text">
                                    <img :src="item.image" style="width: 50px;height: auto"/>
                                </div>
                            </td>
                        </template>
                        <template #operation="{item}">
                            <td>
                                <div class="main__table-btns">
                                    <div @click="edit_item(item)" datas="#"
                                         class="main__table-btn main__table-btn--edit">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                            <path d="M22,7.24a1,1,0,0,0-.29-.71L17.47,2.29A1,1,0,0,0,16.76,2a1,1,0,0,0-.71.29L13.22,5.12h0L2.29,16.05a1,1,0,0,0-.29.71V21a1,1,0,0,0,1,1H7.24A1,1,0,0,0,8,21.71L18.87,10.78h0L21.71,8a1.19,1.19,0,0,0,.22-.33,1,1,0,0,0,0-.24.7.7,0,0,0,0-.14ZM6.83,20H4V17.17l9.93-9.93,2.83,2.83ZM18.17,8.66,15.34,5.83l1.42-1.41,2.82,2.82Z"/>
                                        </svg>
                                    </div>
                                    <div @click="delete_item(item)" datas="#modal-delete"
                                         class="main__table-btn main__table-btn--delete open-modal">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                            <path d="M10,18a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,10,18ZM20,6H16V5a3,3,0,0,0-3-3H11A3,3,0,0,0,8,5V6H4A1,1,0,0,0,4,8H5V19a3,3,0,0,0,3,3h8a3,3,0,0,0,3-3V8h1a1,1,0,0,0,0-2ZM10,5a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1V6H10Zm7,14a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V8H17Zm-3-1a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,14,18Z"/>
                                        </svg>
                                    </div>
                                </div>
                            </td>
                        </template>
                    </Datatable>

                </div>


            </div>
        </div>
        <!-- end form -->
    </div>
</template>

<script>
    import axios from "axios";
    // import {bus} from '../main';
    import Datatable from "@/views/customTable/Datatable";
    import ImageSelector from "@/views/CustomComponent/ImageSelector";

    export default {
        name: 'Country',
        data() {
            return {
                items: [],
                fields: [
                    {key: 'row', label: 'ردیف'},
                    {key: 'title', label: 'نام'},
                    {key: 'image', label: 'تصویر'},
                    {key: 'operation', label: 'عملیات'}
                ],
                status_form: 0,
                name: '',
                bio: '',
                file:null,
                file_preview:'',
                cover_file:null,
                cover_file_preview:'',
            }
        },
        components: {
            Datatable,
            ImageSelector
        },
        mounted() {
            this.get_data();
        },
        methods: {
            edit_item(item) {
                this.name = item.title;
                this.bio = item.summary;
                this.file_preview = item.image;
                this.status_form = item.id;
                this.file=null
            },
            get_data() {

                var self = this;

                var formData = new FormData();

                this.axios.post('get_age_grade', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    self.items = content_data

                }).catch(function (error) {
                    console.log(error);
                });


            },
            insert_data() {

                var self = this;
                if (this.name == "") {
                    return
                }
                var formData = new FormData();
                var url = 'insert_age_grade'
                formData.append('name', this.name);
                formData.append('summary', this.bio);
                formData.append('file', this.file);
                // formData.append('file_cover', this.cover_file);
                if (this.status_form != 0) {
                    formData.append('id', this.status_form);
                    url = 'update_age_grade'
                }
                this.axios.post(url, formData, {}).then(function (response) {

                    self.get_data()
                    self.name = ''
                    self.bio = ''
                    self.file = null
                    self.status_form = 0;

                }).catch(function (error) {
                    console.log(error);
                });


            },
        }
    }
</script>

